import { AxiosResponse } from 'axios';
import { goBack } from 'connected-react-router';
import { AnyAction } from 'redux';
import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError, ShowSuccess } from '../../helper/Alert';
import { IReplyForAllPrams } from '../../interfaces';
import {
  IAssign,
  IQuickAssignParams,
  IRemoveReferFile,
  IUploadReferFile,
} from '../../interfaces/Assign';
import { getLocaleMsg } from '../../lngProvider';
import {
  fetchLetterReferSendTypesSuccess,
  fetchLetterReferTypesSuccess,
  fetchReceiversForReplySuccess,
  onRemoveReferFileSuccess,
  onSendReferSuccess,
  onUploadReferFileSuccess,
} from '../actions';

const getLetterReferTypes = async () => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(`refer/getLetterReferTypes`);
};

const getReceiversForReply = async (parameters: IReplyForAllPrams) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(
    `person/getReceiversForReply?letterCode=${parameters.letterCode}&replyToAll=${parameters.toAll}`,
  );
};

const getLetterReferSendTypes = async () => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(`refer/getLetterReferSendTypes`);
};

const sendRefer = async (parameters: IAssign) => {
  const http = await FaraGostarDynamicHttp();
  await http.post('refer/send', parameters);
};

const fastRefer = async (parameters: IQuickAssignParams) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post('refer/fastRefer', parameters);
};

const uploadReferFile = async (params: IUploadReferFile) => {
  const fd = new FormData();
  fd.append('file', params.file);
  const http = await FaraGostarDynamicHttp();
  return await http.post(
    `refer/UploadReferFile?uploadTaskId=${params.uploadTaskId}&groupId=${params.groupId}&key=${params.key}`,
    fd,
    {
      headers: {
        'content-type': 'multipart/form-data',
      },
    },
  );
};

const removeReferFile = async (params: IRemoveReferFile) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post(`refer/RemoveReferFile`, params);
};

//FAST REFER
function* onFastReferRequest(action: AnyAction) {
  const messages = getLocaleMsg();
  try {
    // const result = yield call(fastRefer, action.payload);
    yield call(fastRefer, action.payload.fastReferModel);
    // yield put(onFastReferSuccess());
    ShowSuccess(messages['messages.FastForwardWasSuccessfully'], '');
    if (action.payload.fromBody == false) {
      yield put(goBack());
      yield put(goBack());
    }
  } catch (error) {
    return ShowError('', error);
  }
}

export function* FastReferRequest() {
  yield takeEvery(ActionTypes.FAST_REFER, onFastReferRequest);
}

function* onSendReferRequest(action: AnyAction) {
  const messages = getLocaleMsg();
  try {
    // const result = yield call(sendRefer, action.payload);
    yield call(sendRefer, action.payload);
    yield put(onSendReferSuccess());
    ShowSuccess(messages['messages.ForwardWasSuccessfully'], '');
    yield put(goBack());
    yield put(goBack());
  } catch (error) {
    return ShowError('', error);
  }
}

export function* sendReferRequest() {
  yield takeEvery(ActionTypes.SEND_REFER, onSendReferRequest);
}

//PersonalArchiveForders
function* fetchLetterReferTypesRequest(): Generator<
  | CallEffect<AxiosResponse<AxiosResponse>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<AxiosResponse>
> {
  try {
    const fetchedLetterReferTypes = yield call(getLetterReferTypes);
    yield put(fetchLetterReferTypesSuccess(fetchedLetterReferTypes.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchLetterReferTypes() {
  yield takeEvery(
    ActionTypes.GET_LETTER_REFER_TYPES,
    fetchLetterReferTypesRequest,
  );
}

function* fetchReceiversForReplyRequest(
  action: AnyAction,
): Generator<
  CallEffect<AxiosResponse<AxiosResponse>> | PutEffect<{ type: ActionTypes }>,
  void,
  AxiosResponse<AxiosResponse>
> {
  try {
    const fetchedReceiversForReply = yield call(
      getReceiversForReply,
      action.payload,
    );
    yield put(fetchReceiversForReplySuccess(fetchedReceiversForReply.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchReceiversForReply() {
  yield takeEvery(
    ActionTypes.GET_RECEIVERS_FOR_REPLY,
    fetchReceiversForReplyRequest,
  );
}

function* fetchLetterReferSendTypesRequest(): Generator<
  CallEffect<AxiosResponse<AxiosResponse>> | PutEffect<{ type: ActionTypes }>,
  void,
  AxiosResponse<AxiosResponse>
> {
  try {
    const fetchedLetterReferSendTypes = yield call(getLetterReferSendTypes);
    yield put(
      fetchLetterReferSendTypesSuccess(fetchedLetterReferSendTypes.data),
    );
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchLetterReferSendTypes() {
  yield takeEvery(
    ActionTypes.GET_LETTER_REFER_SEND_TYPES,
    fetchLetterReferSendTypesRequest,
  );
}

//UPLOAD REFER FILE
function* onUploadReferFileRequest(
  action: AnyAction,
): Generator<
  | CallEffect<AxiosResponse<AxiosResponse>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<AxiosResponse>
> {
  try {
    yield call(uploadReferFile, action.payload);
    yield put(onUploadReferFileSuccess());
  } catch (error) {
    return ShowError('', error);
  }
}

export function* onUploadReferFile() {
  yield takeEvery(ActionTypes.UPLOAD_REFER_FILE, onUploadReferFileRequest);
}

function* onRemoveReferFileRequest(
  action: AnyAction,
): Generator<
  | CallEffect<AxiosResponse<AxiosResponse>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<AxiosResponse>
> {
  try {
    yield call(removeReferFile, action.payload);
    yield put(onRemoveReferFileSuccess());
  } catch (error) {
    return ShowError('', error);
  }
}

export function* onRemoveReferFile() {
  yield takeEvery(ActionTypes.REMOVE_REFER_FILE, onRemoveReferFileRequest);
}

export default function* rootSaga() {
  yield all([
    fork(fetchLetterReferTypes),
    fork(sendReferRequest),
    fork(fetchLetterReferSendTypes),
    fork(fetchReceiversForReply),
    fork(FastReferRequest),
    fork(onUploadReferFile),
    fork(onRemoveReferFile),
  ]);
}
